import { MemberId } from '@wwf/sdk';

export const getLinkToMember = (
    memberId: MemberId | undefined | null,
    type: 'show' | 'show_notes' | 'edit' = 'show'
) => {
    if (!memberId) return '';
    switch (type) {
        case 'show':
            return `/member/${memberId}/show`;
        case 'show_notes':
            return `/member/${memberId}/show/notes`;
        case 'edit':
            return `/member/${memberId}/edit`;
    }
};
